import { Flex } from "@chakra-ui/react";
import { navigate } from "@reach/router";
import { getIconName, Icon } from "assets/Icon";
import {
	DropdownItem,
	DropdownMenu,
	DropdownMenuDrawer,
	DropdownMenuTrigger,
	MenuDivider,
} from "components/RFQ/MenuDropdown";

import { Button } from "newui/components/Button";

type MyTemplatesButtonProps = {
	className?: string;
	companyId: string | number;
	handleCreateTemplate: () => void;
};

export const MyTemplatesButton = ({
	handleCreateTemplate,
	companyId,
	className,
}: MyTemplatesButtonProps) => {
	const listMenuTemplate = [
		{
			name: "Create Template",
			value: "create_template",
			icon: "plus",
			divider: true,
		},
		{
			name: "Manage Templates",
			value: "manage_templates",
			icon: "settings",
			divider: false,
		},
	];

	const handleMenuClick = (value: string) => {
		if (value === "create_template") {
			handleCreateTemplate();
		} else if (value === "manage_templates") {
			navigate(`/account/${companyId}/manage-templates`);
		}
	};

	return (
		<div className={className}>
			<DropdownMenu className="dropdown-menu">
				<DropdownMenuTrigger>
					<Button
						btntype={"secondary"}
						className="!h-[50px]"
					>
						<Flex
							gap={2}
							align={"center"}
						>
							<div className="text-base">My Templates</div>
							<Icon icon="chevron-down" />
						</Flex>
					</Button>
				</DropdownMenuTrigger>
				<DropdownMenuDrawer className="!-right-40">
					{listMenuTemplate.map((menu, index) => {
						const menuIcon = getIconName(menu.icon, "arrow-right-ios");
						return (
							<div key={index}>
								<DropdownItem
									className="w-full"
									onClick={() => handleMenuClick(menu.value)}
								>
									<Icon
										icon={menuIcon}
										color="#667085"
										width={20}
									/>
									<p
										className="font-roboto text-[14px] font-medium text-secondary-700 hover:text-[14px]"
										style={{ lineHeight: "20px" }}
									>
										{menu.name}
									</p>
								</DropdownItem>
								{menu.divider && <MenuDivider />}
							</div>
						);
					})}
				</DropdownMenuDrawer>
			</DropdownMenu>
		</div>
	);
};
